import { render, staticRenderFns } from "./delayRouter.vue?vue&type=template&id=53237fcd&scoped=true&"
import script from "./delayRouter.vue?vue&type=script&lang=js&"
export * from "./delayRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53237fcd",
  null
  
)

export default component.exports